module.exports = __webpack_public_path__ + "static/media/pic2.4497d2c0.jpg";